<template>
  <div v-if="images.length">
    <ul class="tabs" v-if="!this.isPrint">
      <li :class="interiorsClass" v-if="interiors.length">
        <a @click="selectTab($event, 'interiors')" :href="'#interiors_' + leadId">Фотографии</a>
      </li>
      <li :class="layoutClass">
        <a @click="selectTab($event, 'layout')" :href="'#layout_' + leadId">Планировки</a>
      </li>
    </ul>
    <div class="tab-container" v-if="!this.isPrint">
      <div class="tab-pane" :class="interiorsClass" :id="'interiors_' + leadId" v-if="interiors.length">
        <Gallery :images="interiors" :leadId="leadId" galleryType="interiors" />
      </div>
      <div class="tab-pane" :class="layoutClass" :id="'layout_' + leadId">
        <Gallery :images="layout" :leadId="leadId" galleryType="layout" />
      </div>
    </div>

    <Gallery v-if="this.isPrint" :images="images" :leadId="leadId" galleryType="all" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Gallery from './Gallery.vue'


export default {
  name: 'ImagesTabs',
  props: {
    images: {
      type: Array,
      required: true,
    },
    leadId: {
      type: Number,
      required: true,
    },
  },
  components: {
    Gallery,
  },
  computed: {
    ...mapGetters(['isPrint']),
    activeTab() {
      if (this.selectedTab) return this.selectedTab
      return this.interiors.length ? 'interiors' : 'layout'
    },
    interiorsClass() {
      return this.activeTab === 'interiors' ? 'active' : ''
    },
    layoutClass() {
      return this.activeTab === 'layout' ? 'active' : ''
    },
    interiors() {
      return this.images.filter((i, idx) => idx !== (this.images.length - 1))
    },
    layout() {
      return this.images.filter((i, idx) => idx === (this.images.length - 1))
    },
  },
  methods: {
    selectTab(e, tabName) {
      e.preventDefault()
      this.selectedTab = tabName
    }
  },
  data() {
    return {
      selectedTab: null,
    }
  },
}
</script>
